import { useAuthStore } from "@/store/auth";

export function useCurrentUser() {
  return useAuthStore((s) => s.user);
}

/**
 * Returns true for the "elevated" privilege bucket: admin_user OR
 * route_manager. Mirrors DB-level `is_admin()` from migration 0019. Used to
 * gate team-level operations: invite members, manage zones, manage routes,
 * view activity log, see admin nav items, etc.
 *
 * For the three operations that are admin_user-only (lead delete, lead
 * export, role change), use useIsFullAdmin instead.
 */
export function useIsAdmin() {
  return useAuthStore(
    (s) => s.user?.role === "admin_user" || s.user?.role === "route_manager",
  );
}

/**
 * Returns true ONLY for admin_user. Use to gate:
 *   - The Export CSV button on Leads/List
 *   - The Delete lead row action
 *   - The role-change dropdown on the Team page
 * route_manager has "admin" features per useIsAdmin but is deliberately
 * blocked from these three operations. Server-side enforcement lives in
 * the leads_delete RLS policy + set_member_role's is_full_admin() check;
 * this hook keeps the UI honest with the server.
 */
export function useIsFullAdmin() {
  return useAuthStore((s) => s.user?.role === "admin_user");
}
